// extracted by mini-css-extract-plugin
export var icon = "_b0-3";
export var subtitle = "_b0-2";
export var title = "_b0-1";
export var value = "_b0-0";